import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_minus",
  "use": "icon_minus-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 48 48\" id=\"icon_minus\"><path fill=\"currentColor\" d=\"M41.143 19.714H6.857A2.858 2.858 0 004 22.571v2.858a2.857 2.857 0 002.857 2.857h34.286A2.857 2.857 0 0044 25.429V22.57a2.858 2.858 0 00-2.857-2.857z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol